<h1 class="titles">
  <span>1/4</span> Ð¡Ð¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð² Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÐ°ÑÐ¾Ð²
</h1>

<div class="column-container create-ad-container">

  <span>ÐÐ¾Ð¶Ð½Ð¾ Ð½Ð°Ð¿Ð¸ÑÐ°ÑÑ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð² ÑÐ°Ñ Ð¾Ð´Ð½Ð¾Ð³Ð¾, Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¸Ñ Ð¸Ð»Ð¸ Ð²ÑÐµÑ Ð´Ð¾Ð¼Ð¾Ð².</span>
  <span>Ð¡Ð¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¾ÑÐ»Ð¸ÑÐ°ÐµÑÑÑ Ð¾Ñ Ð¾Ð±ÑÑÐ²Ð»ÐµÐ½Ð¸Ñ, ÑÐµÐ¼ ÑÑÐ¾ Ð¾Ð½Ð¾:</span>

  <ul>
    <li>Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð½ÐµÑÐ¾ÑÐ¼Ð°Ð»ÑÐ½ÑÐ¼, Ð¼ÐµÐ½ÐµÐµ Ð¾ÑÐ¸ÑÐ¸Ð°Ð»ÑÐ½ÑÐ¼;</li>
    <li>Ð½Ðµ Ð¾ÑÐ¾Ð±ÑÐ°Ð·Ð¸ÑÑÑ Ð² Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸ Ð² Ð»ÐµÐ½ÑÐµ ÑÐ²ÐµÐ´Ð¾Ð¼Ð»ÐµÐ½Ð¸Ð¹, Ð° Ð¾ÐºÐ°Ð¶ÐµÑÑÑ ÑÑÐµÐ´Ð¸ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ð¹ Ð´ÑÑÐ³Ð¸Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÐµÐ¹.</li>
  </ul>

</div>

<lib-button routerLink="/management-company/chats/message-text">ÐÐ°ÑÐ°ÑÑ</lib-button>
